import { TSelectOptionValue } from "types/select-input.type";
import {
  ISelectInputOptionProps,
  SelectInputOptionBase,
} from "components/select-input/SelectInputOptionBase";
import { useMemo } from "react";
import { Box } from "@chakra-ui/react";

export function LeadAttributionItemSelectInputOption<
  D extends TSelectOptionValue,
  S = unknown
>({
  optionProps: { option, selectedOption, ...rest },
}: ISelectInputOptionProps<D, S>) {
  const isSelected = useMemo(() => selectedOption?.value === option.value, [
    selectedOption,
    option,
  ]);
  const isDisabled = false;

  return (
    <SelectInputOptionBase
      option={option}
      isSelected={isSelected}
      isDisabled={isDisabled}
      {...rest}
    >
      <Box maxWidth={"200px"} isTruncated={true}>
        {option.label}
      </Box>
    </SelectInputOptionBase>
  );
}
